import { createRouter, createWebHistory } from 'vue-router'
import Cookies from 'js-cookie'
import auth from './auth';
import home from './home';

const routes = [
  ...auth,
  ...home,
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/HomeView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/home/SettingsView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/finances',
    name: 'finances',
    component: () => import('@/views/finance/FinancesView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/senders',
    name: 'senders',
    component: () => import('@/views/senders/SendersView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/external-services',
    name: 'external-services',
    component: () => import('@/views/external_service/ExternalServicesView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/models',
    name: 'models',
    component: () => import('@/views/models/ModelsView.vue'),
    meta: {
      requiresAuth: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuth = !!Cookies.get('access_token');

  if (to.meta.requiresAuth && !isAuth) {
    // нужно авторизоваться
    next('/login');
  } else if (to.meta.guestOnly && isAuth) {
    // уже авторизован, не пускаем на логин/регу
    next('/home'); // например, главная после логина
  } else {
    next();
  }
});

export default router
